import { AdminApi } from 'stylemix-vue-admin'

export default class ReviewsApi extends AdminApi {
  constructor(parameters) {
    super('reviews', parameters)
  }

  reply(review, reply) {
    return this.submit('POST', `${this.endpoint}/${review.id}/reply`, { reply })
  }
}
